import styled from 'styled-components';

export default styled.div`
	max-height: var(--px-140);
	.comp-doc-link {
		max-width: unset;
		.DocumentNameWrapper {
			.DocumentNameContainer {
				.DocumentNameDetails {
					width: unset;
				}
			}
		}
	}
`;
